import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

const CITIES = ["Praha", "Brno", "Ostrava", "Plzeň", "Liberec", "Olomouc", "Hradec Králové", "České Budějovice"];

export const Footer = () => {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-white">
      <div className="container-page py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 font-display font-extrabold text-xl mb-3">
            <span className="inline-block w-8 h-8 rounded-lg bg-gradient-to-br from-sky-400 to-sky-600 grid place-items-center text-white">
              <Sparkles className="w-4 h-4" />
            </span>
            Pranidomu<span className="text-sky-600">.cz</span>
          </div>
          <p className="text-sm text-slate-500 leading-relaxed">
            Vyzvednutí, vyprání a doručení prádla přímo k vašim dveřím.
            Marketplace, který propojuje domácnosti s lokálními prádelnami.
          </p>
        </div>
        <div>
          <h4 className="tiny-label mb-3">Platforma</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/jak-to-funguje" className="hover:text-sky-600">Jak to funguje</Link></li>
            <li><Link to="/cenik" className="hover:text-sky-600">Ceník</Link></li>
            <li><Link to="/pro-pradelny" className="hover:text-sky-600">Stát se prádelnou</Link></li>
            <li><Link to="/airbnb" className="hover:text-sky-600">Pro Airbnb &amp; ubytování</Link></li>
            <li><Link to="/kontakt" className="hover:text-sky-600">Kontaktujte nás</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="tiny-label mb-3">Praní v okolí</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            {CITIES.slice(0, 6).map((c) => (
              <li key={c}>
                <Link to={`/prani-pradla/${c.toLowerCase().replace(/[áéěíóúůý\s]/g, (m) => ({"á":"a","é":"e","ě":"e","í":"i","ó":"o","ú":"u","ů":"u","ý":"y"," ":"-"}[m] || m))}`} className="hover:text-sky-600">
                  Praní prádla {c}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 py-5 text-xs text-slate-400 text-center">
        © {new Date().getFullYear()} Pranidomu.cz – všechna práva vyhrazena.
      </div>
    </footer>
  );
};
